<template>
    <div class="form-group form-group--button">
        <div class="share-list-btn">
            <a href="javascript:void(0)" type="button" class="btn btn-primary" :class="{'disabled' : !enabled}" v-on:click="openModal">
                {{text}}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShareButton",
        props: {
            text: String,
            enabled: Boolean
        },
        methods: {
            openModal() {
                if(this.enabled){
                    window.showShareFavoritesModal('shareFavoritesLink')
                }
            }
        }
    }
</script>

<style scoped>

</style>